import React from 'react';

const HeaderLang = ({ name, label, changeLanguage, activated }) => {
  return (
    <div onClick={() => changeLanguage(name)} className={(activated===name) ? 'el-lang-button button chosen-language' : 'el-lang-button button'}>
      {name}
    </div>
  );
};

export default HeaderLang;